import { render, staticRenderFns } from "./ActionsFailureDialog.vue?vue&type=template&id=70a99a12&"
import script from "./ActionsFailureDialog.vue?vue&type=script&lang=js&"
export * from "./ActionsFailureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports